// This is the project importer that injects itself, a loader and a Vue mount element
// Into Volvo cars website.

// Import polyfill to support all modern and old browsers
import 'babel-polyfill'
import 'generic/polyfill/prepend.es6'

// Import preloader styles
import styleLoader from 'generic/styles/preloader.scss'

// This file is a loader for the chunk that is required.
// It dynamically imports it as a promise
const Importer = () => import('./client.es6')

const AddFbiHook = () => {
    // Find correct reference point for injection
    let referencePoint = document.getElementsByTagName('footer')
    if (referencePoint.length <= 0) {
        referencePoint = document.getElementsByTagName('body')
    }

    // Create an element, and give it correct id
    const hook = document.createElement('div')
    hook.setAttribute('id', 'fbi-content')

    // Prepend the element
    referencePoint[0].parentNode.insertBefore(hook, referencePoint[0])
}

const AddLoader = () => {
    // Set referencePoint for injection
    const referencePoint = document.getElementsByTagName('body')

    // Create elements and apply styles
    const loaderWrap = document.createElement('div')
    loaderWrap.classList.add(styleLoader.fbinhouse_spacer)
    const loader = document.createElement('div')
    loader.classList.add(styleLoader.fbinhouse_loader)
    loaderWrap.appendChild(loader)

    // Prepend loader
    referencePoint[0].prepend(loaderWrap)
    return loaderWrap
}

// When DOM is loaded, mount the application.
window.document.addEventListener('DOMContentLoaded', () => {
    // Injects a loader with custom css elements
    const loader = AddLoader()

    // Injects an element that Vue instance can hook to
    AddFbiHook()

    // Once all dependencies has been loaded, mount Vue instance.
    Importer().then((client) => {
        client.default.$mount('#fbi-content')
        loader.classList.add(styleLoader.fbinhouse_spacer_fadeout)
    })
})


// WEBPACK FOOTER //
// ./generic/importer.es6